/**
 * The depth texture of a shadow atlas that the soft shadow filter samples: a depth compare under a
 * linear filter, and one texture that every material samples through one sampler.
 */
import * as THREE from 'three';
import { sharedTexture } from '../sharedTexture.js';
export class AtlasDepthTexture extends sharedTexture(THREE.DepthTexture) {
    constructor({ name, size, type, compare }) {
        super(size, size, type);
        this.name = name;
        this.format = THREE.DepthFormat;
        this.compareFunction = compare;
        this.minFilter = THREE.LinearFilter;
        this.magFilter = THREE.LinearFilter;
    }
}
//# sourceMappingURL=atlasDepthTexture.js.map